module.exports = __webpack_public_path__ + "static/media/06.e993142b.jpg";